import { Component, Input } from '@angular/core';
import { UserService } from '../Services/user';
import { AlertService } from '../Services/alert';
import { User } from '../Models/user';


@Component({
  selector: 'profile-bankaccount',
  templateUrl: '../Templates/profile.bankaccount.html'
})


export class ProfileBankaccountComponent {

  @Input()
  public user: User;

  checked: boolean;

  constructor(private userService: UserService,
              private alerts: AlertService
             ) { }

  ngOnInit() {
    if (this.user.bankaccount) {
      this.checked = true;
    }
  }

  saveBankAccount(): void {
    if (this.checked) {
      this.userService.update(this.user).subscribe(
        user => {
          this.user = user;
          this.alerts.success("Profile updated");
        },
        err => { this.alerts.error(err) })
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/Components/profile.bankaccount.ts